<div
  class="form-group text-area-input-element"
  [ngClass]="{ 'small-margin': smallMargin }"
>
  <label for="value" class="text-area-label">{{ label }}</label>
  <textarea
    [autofocus]="hasExternalError"
    [rows]="rows"
    cols="1"
    class="form-control text-area-style"
    [(ngModel)]="value"
    [maxlength]="maxChars"
    name="value"
    [ngClass]="{ 'over-max-chars': checkIfOverMaxChars() || hasExternalError }"
    (ngModelChange)="update($event)"
  ></textarea>
  <p
    *ngIf="value"
    class="char-max"
    [ngClass]="{ 'over-max-chars-text': checkIfOverMaxChars() }"
  >
    {{ value.length }}/{{ maxChars }} character max
  </p>
</div>
